import { Upgrade } from "@mui/icons-material";
import PlanCheckout from "../../PlanCheckout/PlanCheckout";

export default {
  translations: {
    otpDialog: {
      button: "Remover senha de uso único",
      title: "Tem certeza que deseja remover sua senha de uso único?",
      contentEmail: "E-mail da conta:",
      content: "Saiba que após confirmar, as configurações de autenticação de multifatores de sua conta serão retiradas. E posteriormente deverão ser configuradas novamente.",
      successfullyOtpPass: "Senha de uso único aceita com sucesso.",
      successfullyOtpPassContent: "Sua senha de uso único foi aceita com sucesso. Clique em confirmar para ser redirecionado ao login e acessar a aplicação."
    },
    TwoFa: {
      title: "Foi enviado um código",
      message: "Um código foi enviado para o seu email.",
      button: "Digitar este código"
    },
    Novo: {
      message: 'Novo'
    },
    Nome: {
      message: 'Nome do documento',
      text: 'Nome',
      folder: 'Nome da pasta',
      username: 'Nome do usuário',
      workspace: 'Nome do Workspace',
      group: 'Nome do Grupo',
      validation: 'Nome da Validação',
      organization: 'Nome da Organização'
    },
    D4Sign: {
      Confi: 'Configuração D4 Sign',
      SafeBox: 'Cofre',
      Error: 'D4Sign retornou erro',
      Download: 'Download documento assinado',
      Wait: 'Aguardo, estamos preparando o link'
    },
    Sensibility: {
      word: "Sensibilidade",
      higth: "Alta",
      medium: "Média",
      low: "Baixa"
    },
    Type: {
      message: 'Tipo'
    },
    Extencao: {
      message: 'Extensão'
    },
    Editar: {
      message: 'Editar'
    },
    Excluir: {
      message: 'Excluir'
    },
    Clone: {
      message: 'Clonar'
    },
    Iniciais: {
      message: 'Iniciais'
    },
    NomeInterno: {
      message: 'Nome interno'
    },
    UsuariosAdm: {
      message: 'Usuários owners'
    },
    ConfigWork: {
      message: 'Configurações do Workspace'
    },
    Salvar: {
      message: 'Salvar'
    },
    Deletar: {
      message: "Deletar"
    },
    Resetar: {
      message: "Resetar"
    },
    SalvarWork: {
      message: 'Salvar Workspace'
    },
    CloneWork: {
      message: 'Clonar Worskpace'
    },
    Cancelar: {
      message: 'Cancelar'
    },
    Fechar: {
      message: 'Fechar'
    },
    Filters: {
      message: 'Filtros'
    },
    WorkSalvo: {
      message: 'Workspace salvo'
    },
    ErroAoSalvar: {
      message: 'Não conseguiu salvar'
    },
    CanNotClone: {
      message: 'Não conseguiu clonar'
    },
    UsuariosSugeridos: {
      message: 'Usuários sugeridos'
    },
    UsuariosNaoEncontradors: {
      message: 'Usuários não encontrados'
    },
    SalvoOK: {
      message: 'Salvo Ok'
    },
    AdmOrg: {
      message: 'Root da organização '
    },
    OnlyRead: {
      message: 'Somente leitura'
    },
    SignInWithMicrosoft: {
      message: "Login com Microsoft"
    },
    MinDeCaracteres: {
      message: 'Nome deve conter 3 ou mais caracteres'
    },
    SalvarUsuario: {
      message: 'Salvar Usuário'
    },
    ExluirUsuarioValid: {
      message: 'Tem certeza que deseja excluir o usuário'
    },
    UserExcluido: {
      message: 'Usuário excluído.',
      error: 'Error: User cant deleted.'
    },
    Continuar: {
      message: 'Continuar'
    },
    Usuarios: {
      message: 'Usuários'
    },
    Org: {
      saveOk: 'Organização salva'
    },
    SalvarOrg: {
      message: 'Salvar Organização'
    },
    NomeOrg: {
      message: 'Nome da Organização'
    },
    NomeWorkspace: {
      message: 'Nome do Workspace'
    },
    ExcluidoComSucesso: {
      message: 'Excluído com sucesso'
    },
    EditadoComSucesso: {
      message: 'Editado com sucesso'
    },
    ConfigOrg: {
      message: 'Configurações de Organização'
    },
    ExcluirOrg: {
      message: 'Excluir organização'
    },
    CertezaExcluir: {
      message: 'Tem certeza que deseja excluir?'
    },
    CertezaExcluirOrganization: {
      message: 'Tem certeza que deseja excluir esta Organização?'
    },
    Workspace: {
      permission: "Privilégios do Workspace",
      reader: "Leitor",
      writer: "Editor",
      none: "Desativar",
      deleteSucess: "Workspace deletado",
      createSucess: "Workspace criado",
      cloneSucess: "Workspace clonado",
      updateSuccess: "Workspace atualizado",
    },
    WorkspaceList: {
      Documents: "Documentos",
      HeaderText: "Gerencie seus documentos: acompanhe o status de pendências, aprovações e rejeições de forma simples e eficiente.",
      DocumentActions: "Ações em documentos",
      DocumentActionsDisabledTooltip: "Selecione pelo menos 2 arquivos para usar esta ação.",
      New: "Adicionar documento",
      NoItens: "Não há itens por aqui",
      NoItensText: "Infelizmente não há documentos ou pastas disponíveis no momento."
    },
    Item: {
      permission: "Privilégios do Item",
      reader: "Leitor",
      writer: "Editor",
      none: "Desativar",
      deleteSucess: "Item deletado",
      deleteProblem: "Item problema na exclusão",
      createSucess: "Item criado",
      folow: "Seguir pai",
      isFolow: "Seguir",
      dontFolow: "Não Seguir",
      deleteBtn: "Deletar ",
      editBtn: "Editar",
      deleteMessage: "Tem certeza que deseja excluir?",
      deleteMessageFolder: "Tem certeza que deseja excluir a pasta?",
      deleteMessageFile: "Tem certeza que deseja excluir o arquivo?",
      deleteDescription: "Confirme se realmente deseja enviar {{itemName}} para a lixeira. Será possível restaurar posteriormente.",
      setDraft: "Rascunho",
      download: "Baixar",
      setRelease: "Publicar",
      d4SignVersion: "Ver versão assinada",
      undoDraft: "Descartar Rascunho",
      undo: "Desfazer",
      folder: "Pasta"
    },
    CertezaExcluirWorkspace: {
      message: 'Tem certeza que deseja excluir este Workspace?'
    },
    EscrevaNomeOrg: {
      message: 'Escreva o nome da organização'
    },
    NomeIncorreto: {
      message: 'Nome incorreto'
    },
    Organizacoes: {
      message: 'Organizações'
    },
    GrupoSalvo: {
      message: 'Grupo salvo'
    },
    AlterarUsuarios: {
      message: 'Alterar usuários'
    },
    SalvarGrupo: {
      message: 'Salvar Grupo'
    },
    GrupoExcluido: {
      message: 'Grupo excluído.'
    },
    CertezaExcluirGrupo: {
      message: 'Tem certeza que deseja excluir o grupo?'
    },
    Adicionar: {
      message: 'Adicionar'
    },
    AdicionarUsuario: {
      message: 'Adicionar Usuário'
    },
    UsuarioDoGrupo: {
      message: 'Usuários do grupo'
    },
    Grupos: {
      message: 'Grupos'
    },
    TiposDeDocumento: {
      message: 'Tipos de Documento'
    },
    ValidationRule: {
      menu: 'Regras de Validação',
      errorFind: 'Não encontrada regra de validação',
      saveOk: 'Regra de Validação salva',
      error: 'Erro no salvar',
      addActivity: "Adicionar Atividade do Workflow",
      backOperationLabel: "Label para Voltar",
      forwardOperationLabel: "Label para Avançar",
      dinamic: "Responsável dinâmico",
      erroName: "Nome não deve ser vazio",
      erroBackOperationLabel: "Label Voltar não deve ser vazio",
      erroForwardOperationLabel: "Label Avançar não deve ser vazio",
      erroItensTagUser: "Deve ter pelo menos um responsável",
      doYouWantToRemoveTheValidationRuleUsedOnTheseFiles: "Tem certeza que deseja remover esta regra de validação? Não será mais possível adicionar documentos a ela. Os documentos que já estão neste fluxo seguirão até serem liberados",
      erroTermTypes: "Erro em procurar os tipos de prazo",
	  NoTerm: "Sem prazo",
      UserTerm: "Prazo definido pelo usuário",
      ActivityTerm: "Prazo definido na atividade",
      AddNewActivity: "Adicionar nova atividade",
      ActivityDescriptor: "Crie uma nova regra de validação para garantir que os dados irão estar de acordo com os critérios estabelecidos.",
      Consensual: "Aprovação consensual",
      newValidationRule: "Nova regra de validação",
      saveValidationRule: "Salvar regra de validação",
      validationRuleInformation: "Informações da regra",
      validationRuleName: "Nome da regra",
      validationRuleDescription: "Descrição",
      validationActivity: "Atividades da regra",
      validationRuleSteps: "Especifique as etapas que o documento deve seguir ao longo do fluxo de atividade",
      MoveUp: "Mover para cima",
      MoveDown: "Mover para baixo",
      RemoveLines: "Remover linhas",
      ActivityName: "Nome da atividade",
      ActivityResponsable: "Responsável",
      ActivityTermT: "Prazo",
      EditInformation: "Editar informações",
      DeleteVr: "Deseja realmente deletar a regra de validação?",
      ConfirmDelete: "Confirme se você realmente deseja deletar a regra de validação.",
      AprovalAct: "Atividade de aprovação",
      AssignAct: "Atividade de assinatura",
      AssignActError: "Atividade de assinatura não pode ter mais de um responsável.",
      ValidationruleListTitle: "Regras de validação",
      ValidationRuleListDescription: "As regras de validação são critérios estabelecidos para verificar se os dados estão atendendo os requisitos.",
      ValidationRuleListCreateButton: "Criar regra de validação",
      SelectUser: "Selecionar usuário...",
      NoValidationRule: "Nenhuma regra de validação foi configurada.",
      NoValidationRuleText: "Defina critérios para validar os dados corretamente.",
      UserConcensualNotAllowed: "Aprovação concensual só pode ser feita por dois usuários."
    },
    Empity: {
      message: 'Vazio'
    },
    Arvore: {
      message: 'Árvore'
    },
    Configuracoes: {
      message: 'Configurações'
    },
    Expandir: {
      message: 'Expandir'
    },
    Diminuir: {
      message: 'Diminuir'
    },
    Sair: {
      message: 'Sair'
    },
    AlteradoComSucesso: {
      message: 'Alterado com sucesso'
    },
    AssinadoComSucesso: {
      message: "Assinado com sucesso"
    },
    FinalizadoComSucesso: {
      "message": "Documento finalizado."
    },
    AlgoErradoAconteceu: {
      message: 'Algo errado aconteceu'
    },
    SenhasNaoBatem: {
      message: 'Os caracteres inseridos estão incorretos.'
    },
    CodigoNaoEncontrado: {
      message: 'Código não encontrado.'
    },
    SemCodigo: {
      message: 'Sem código'
    },
    Senha: {
      message: 'Senha',
      newPassword: 'Nova senha',
      typeYourPassword: "Digite sua senha...",
      typeYourPasswordAgain: "Digite sua senha novamente...",
      newPasswordRequirements: "A senha deve ter no mínimo 6 caracteres, sendo eles: uma letra maiúscula, um caractere especial e um número."
    },
    ConfirmarSenha: {
      message: 'Confirmar nova senha'
    },
    Enviar: {
      message: 'Enviar'
    },
    Confirmar: {
      message: 'Confirmar'
    },
    IrParaLogin: {
      message: 'Retornar para login',
      message2: 'Ir para login'
    },
    Entrar: {
      message: 'Entrar',
      forgotPassword: 'Esqueceu sua senha',
      codPage: "Ir para a página de código do e-mail",
      characterMinimun: "Mínimo de caracteres",
      specialcharacters: "Um caractere especial",
      oneNumber: "Senha contendo número",
      capitalLetter: "Uma letra maiúscula",
      registrar: "Registrar"
    },
    InsiraEmail: {
      message: 'Insira seu e-mail cadastrado'
    },
    InsiraSenha: {
      message: 'Insira sua senha cadastrada'
    },
    Code: {
      message: 'Código',
      acepted: 'Código aceito',
      header: 'Código por e-mail'
    },
    AccessCode: {
      message: 'Acesso por código',
      label: 'Código de acesso',
      info:
        'Você recebeu um código de acesso para acessar a plataforma? Insira este código no campo abaixo.'
    },
    LembrarDeMim: {
      message: 'Lembrar de mim'
    },
    EsqueceuSenha: {
      message: 'Esqueceu sua senha?'
    },
    UsuarioOuSenhaIncorretors: {
      message: 'Usuário ou senha incorretos'
    },
    UsuarioOuCodeIncorretors: {
      message: 'Usuário ou código incorretos'
    },
    DoitLogin: {
      message: 'Faça o login',
      sucess: "Codigo aceito"
    },
    Upload: {
      done: 'Finalizado',
      error: 'Ocorreu um erro',
      file: "Documento",
      folder: "Carregar pasta",
      newFolder: "Pasta",
      permission: "Privilégios",
      permissionGroup: "Privilégios de Grupos",
      permissionUser: "Privilégios de Usuários",
      notEnoughStorage: "Sem armazenamento suficiente"
    },
    NotFound: {
      message: "Não encontrado"
    },
    Datadamodificacao: {
      message: "Criado em"
    },
    Modificadopor: {
      message: "Modificado por"
    },
    Tamanhodoarquivo: {
      message: "Tamanho"
    },
    Folder: {
      save: "Salvo com sucesso",
      toSave: "Alteração"
    },
    FolderStructure: {
      title: "Estrutura de pastas"
    },
    DownloadFileError: {
      message: "Erro no Download"
    },
    PdfPageLoadError: {
      message: "Ocorreu um erro ao carregar a página do documento PDF."
    },
    ReleaseError: {
      message: "Colocar Release com erro"
    },
    DraftError: {
      message: "Colocar Draft com erro"
    },
    ArcinvingError: {
      message: "Colocar Em Archiving com erro"
    },
    SucessMove: {
      message: "Movido com sucesso",
      error: "Arquivo não foi movido"
    },
    Start: {
      message: "Iniciar"
    },
    Action:  {
      message:  "Ações",
      send:  "Enviar para regra de validação"
    },
    ErrorMove: {
      message: "Erro ao mover!"
    },
    Revisao: {
      term: "Revisões",
      tracker: "Rastreador de Atividades",
      time: "Tempo",
      ipUser: "Ip",
      name: "Nome do usuário",
      message: "Mensagem",
      noEntries: "No Entries"
    },
    DownloadSuccess: {
      message: "Dowload feito com sucesso!"
    },
    DraftDate: {
      message: "Data criação"
    },
    Atualizar: {
      message: "Atualizar"
    },
    Description: {
      message: "Descrição"
    },
    CertezaExcluirDocumentType: {
      message: 'Tem certeza que deseja excluir este tipo de documento?'
    },
    DocumenType: {
      deleteSucess: "Tipo de documento deletado!",
    },
    New: {
      female: "Nova",
      male: "Novo"
    },
    ValidationRules: {
      NewActivity: "Nova Atividade",
      Deleted: "Tem certeza que deseja excluir esta regra de validação?",
      DeletedOk: "Regra de validação deletada",
      RemovedOK: "Regra de validação removida"
    },
    Select: {
      message: "Selecione",
      error: "Erro ao procurar parâmetros"
    },
    Responsible: {
      message: "Responsável",
      select: "Selecionar Responsável",
      suggestions: "Responsáveis Sugeridos",
      notFound: "Nenhum responsável encontrado",
      lessOne: "Mínimo um responsável"
    },
    ActivityName: {
      message: "Nome da Atividade"
    },
    Pendencias: {
      message: "Pendências",
      text: "Gerencie seus documentos: acompanhe o status de pendências, aprovações e rejeições de forma simples e eficiente."
    },
    CertezaExcluirPermission: {
      message: 'Tem certeza que deseja excluir este tipo de permissão?'
    },
    Label: {
      Back: "Label para Voltar",
      Forward: "Label para Avançar"
    },
    CPF: {
      choice: 'D4 Sign',
      invalid: 'CPF Inválido',
      nextStep: 'Validar',
      SaveInServer: 'Salvando no servidor'
    },
    foreign: {
      message: 'Estrangeiro'
    },
    loadMore: {
      text: "Carregar mais",
      error: "Não encontrado mais regras de validações"
    },
    Exibir: {
      message: "Exibir"
    },
    UsuarioSalvo: {
      message: "Usuário Salvo"
    },
    MaxDeCaracteres: {
      message: 'O nome deve ter no máximo 50 caracteres'
    },
    Copy: {
      message: 'Copiado com sucesso!',
      error: 'Erro ao copiar!'
    },
    Wait: {
      message: "Aguarde"
    },
    ErroMail: "E-mail inválido",
    SharedFile: {
      Error: "Erro a consultar",
      Menu: "Compartilhar arquivo",
      FileDontShared: "Arquivo não compartilhado",
      ToShare: "Compartilhar",
      AddEmail: "Adicionar e-mail",
      EndedByDay: "Compartilhar até",
      EndedByAcces: "Compartilhar até chegar a quantos acessos",
      WithoutEnded: "Não expira",
      ErroOnDelete: "Aconteceu um erro ao deletar",
      ErroOnSave: "Aconteceu um erro ao salvar",
      NotCheckBox: "É necessário marcar uma caixa de seleção",
      ListEmails: "Lista deve ter e-mails",
      HasWatermark: "Compartilhar com marca d'água"
    },
    TextField: {
      TooltipTitle: "Clique no botão para adicionar e-mail."
    },
    permissionDriveOrg: {
      message: "Atribuir permissão para o drive",
      permission: "Permissão drive"
    },
    renameItem: {
      message: "Renomear ",
      error: "Erro ao renomear"
    },
    editItem: {
      message: "Editar "
    },
    owner: {
      message: "Proprietário da pasta"
    },
    permissionFolder:  {
      message:  "Privilégios"
    },
    Visualizador: {
      message: "Visualizador"
    },
    PermicoesItem:  {
      message:  "Privilégios do item",
    },
    Move: {
      moveBy: "Mover para",
      message: "Mover ",
      to: " para ",
      toRoot: "Mover para raiz",
      root: " para raiz",
    },
    AcaoExecutada: {
      message: "Ação Executada"
    },
    RevisaoDocument: {
      message: "Revisão do Documento"
    },
    Usuario: {
      message: "Usuário"
    },
    DateAction: {
      message: "Data da ação"
    },
    ErrorDate: {
      Begin: "Data inicial não pode ser maior que a final.",
      End: "Data final não pode ser menor que a inicial."
    },
    NewResp: {
      message: "Selecione novo responsável",
    },
    ArqResp: {
      message: "Arquivos que o usuário é responsável.",
    },
    SelectResp: {
      message: "Selecione o novo usuário para a regra de validação.",
    },
    Organizador: {
      message: "Organizador",
    },
    Common: {
      message: "Comum",
      Guest: "Convidado"
    },
    CalendarLabel: {
      message: "Vencimento",
      toolTipMessage: "O vencimento define o tempo de validade de um documento.",
      From: "De:",
      To: "Até:",
    },
    CalendarButtonToday: {
      TodayButton: "Hoje",
    },
    ReturnEmptyTracker: {
      MessageSnack: "Não encontrado o Tracker",
    },
    NameExist: {
      message: "Nome já existe!"
    },
    Rejeitado: {
      message: "Rejeitado com sucesso!"
    },
    Arquivar: {
      message: "Arquivar"
    },
    ResetPasswordRequest: {
      message: "Redefinir senha"
    },
    InvalidEmail: {
      message: "Email inválido"
    },
    EmailSent: {
      message: "Email enviado"
    },
    StroageInformation: {
      bookcase: "Estante",
      shelf: "Prateleira",
      position: "Posição / Caixa",
      menu: "Localização Física",
      additionalInformation: "Informações adicionais"
    },
    Delete: {
      message: "Excluir"
    },
    Remove: {
      message: "Remover"
    },
    SelectValidationRule: {
      message: "Selecione a regra de validação"
    },
    ValidationRuleCanceled: {
      message: "Regra de validação cancelada!"
    },
    NotificationEmail: {
      message: "Receber notificação por e-mail"
    },
    EditFolder: {
      title: "Editar Pasta",
      information: "Informações",
      folderName: "Nome da pasta",
      sensitivity: "Sensibilidade",
      owner: "Proprietário",
      notifications: "Notificações",
      updateInformation: "Atualizar informações",
      receiveEmailNotifications: "Receber notificações por e-mail."
    },
    ActionsInBatch: {
      message: "Ações em lote"
    },
    FilesWentToRelease: {
      message: "Arquivos foram para Release"
    },
    ErrorWhenUpdatingToRelease: {
      message: "Erro ao atualizar para release"
    },
    FilesWentToDraft: {
      message: "Arquivos foram para Draft"
    },
    ErrorWhenUpdatingToDraft: {
      message: "Erro ao atualizar para Draft"
    },
    UploadAsRelease: {
      message: "Upload como Release"
    },
    OrganizerCannotDelete: {
      message: "Organizador não pode excluir"
    },
    EditorCannotDelete: {
      message: "Editor não pode excluir"
    },
    EditorCannotSeeRevision: {
      message: "Editor não verá revisões"
    },
    WorkspaceAlwaysWithWaterMark: {
      message:"Compartilhar sempre com marca d'agua."
    },
    WorkspaceAlwaysWithWaterMarkWarning: {
      message:"Opção de workspace sempre com marca d'agua ativa."
    },
    FolderWithHighSensitivitySharedWarning: {
      message:"Arquivos compartilhados em pastas com sensibilidade alta sempre irão ser compartilhados com marcas d'agua."
    },
    Undo: {
      message: "Desfazer"
    },
    ConfirmTheDiscardOfTheDraft: {
      message: "Essa ação é irreversível! Confirma o descarte do Draft?"
    },
    Term: {
      message: "Prazo",
      days: "Dias",
      select: "Selecione um Prazo",
      addTerm: "Adicionar tipo de prazo",
      current: "Prazo limite",
      on: "Prazo positivo",
      out: "Prazo vencido",
      noDeadline: "Sem prazo"
    },
    FileDownload: {
      message: "Download do arquivo"
    },
    NoViewerModal: {
      title: "Não é possível visualizar este arquivo",
      content: "O arquivo que você está tentando visualizar não possui visualização para leitura. Para conseguir visualizá-lo, clique no botão abaixo para fazer download e acesse o arquivo."
    },
    WhatAreYouLookingFor: {
      message: "O que você está procurando..."
    },
    Search: {
      message: "Pesquisar..."
    },
    informationModal:  {
      message:  "Informação para quem foi enviada a Validation"
    },
    termRule:  {
      message:  "Escolha um prazo para a regra de validação.",
      select:  "Selecione um Prazo"
    },
    tag:  {
      editMessage:  "Tag editada com sucesso!",
      addMessage:  "Tag adicionada com sucesso!",
      errorEdit:  "Erro ao editar tag",
      errorAdd:  "Erro ao adicionar tag",
      notFound:  "Tags não encontradas",
      new:  "Nova Tag",
      suggested:  "Tags Sugeridas",
      edit:  "Editar Tags",
      add:  "Adicionar Tags",
      insertMessage:  "Insira tags em arquivos e pastas para facilitar o acesso e encontrar facilmente o que procura.",
      LoadingResults:  "Carregar mais resultados...",
      save:  "Salvar Informações",
      cancel:  "Cancelar",
      nameFile:  "Nome de arquivo",
      descFile:  "Descrição",
      semDesc:  "Sem descrição",
      fileTag:  "Tags do arquivo",
      tagExist:  "Nome já existe",
      messageTag:  "Tag já existe",
      NoTag: "Sem tag"
    },
    validationRulePanel: {
      select: "Selecione a regra de validação que está de acordo com a necessidade atual do documento.",
      execution: "Execução",
      selectUser: "Selecione o responsável que irá executar a regra de validação selecionada acima.",
      alreadySetConfig: "Configurações já colocadas na regra de validação.",
      alreadySetValidation: 'As configurações da validação já foram alocadas na tarefa. Clique em "Enviar para responsável" para continuar.',
      sendToResponsible: "Enviar para responsável",
      OkUnderstand: "Certo, entendi",
      validationRuleSubmit: "Regra de validação enviada com sucesso",
      validationRuleData: "A regra de validação foi enviada para o responsável que corresponde com os dados listados abaixo.",
      responsible: "Responsável",
      withTerm: "Sem prazo.",
      emailWrong: "O item que estava pendente foi concluído com sucesso. Você pode desconsiderar o e-mail recebido e fechar esta janela.",
      responsableError: "Responsável deve ser definido.",
      norVrFounded: "Nenhuma regra de validação encontrada.",
      title: "Regra de validação",
      termError: "Um prazo deve ser definido."
    },
    substituir: {
      message: "Substituir"
    },
    DetailDocumentPage: {
      Actions: "Ações",
      Save: "Salvar",
      Description: "Sem descrição...",
      ModDate: "Data de modificação",
      ModResp: "Responsável  do documento",
      Term: "Prazo",
      NoTerm: "Sem prazo...",
      Visualization: "Visualização",
      ActivityTracker: "Rastreador de atividades",
      Location: "Localização Física",
      Reviews: "Revisões"
    },
    Wizard: {
      organization: "Organização",
      password: "Senha",
      confirmPassword: "Confirme sua senha",
      welcome: "Bem vindo(a)!",
      return: "Retornar",
      continue: "Avançar",
      conclude: "Concluir cadastro",
      name: "Nome",
      addUsers: "Adicionar",
      errorUsers: "Número de usuários inválidos",
      emailInfo: "Adicionar até 5 colaboradores para fazer parte do ambiente de trabalho da empresa",
      descriptionEnd: "Verifique se as informações cadastradas abaixo estão corretas. Se sim, clique em \"",
      descriptionEndBold: "Concluir Cadastro",
      descriptionEndSecond: "\".",
      maxUserlength: "Máximo cinco usuários",
      fillAllFields: "Preencha corretamente.",
      emailAlreadyInList: "E-mail já está na lista."
    },
    Login: {
      forgotPass: "Esqueci minha senha",
      password: "Senha",
      goToEmailPage: "Ir para página de código do e-mail",
      accessAcount: "Acessar Conta",
      helloAgain: "Olá, novamente! Preencha os campos abaixo com os seus dados para acessar a sua conta.",
      putYourNewPass: "Insira a nova senha",
      fillTheFieldsDown: "Preencha os campos abaixo com a sua nova senha.",
      forgotYourPass: "Esqueceu sua senha?",
      fillTheEmailRegistered: "Preencha o campo abaixo com o seu e-mail cadastrado para recuperar a sua senha.",
      typeYourEmail: "Digite o seu e-mail...",
      typeYourPassword: "Digite a sua senha...",
      accessWithCode: "Acesso por código",
      doYouReceived: "Você recebeu um código de acesso para acessar a plataforma? Insira este código no campo abaixo.",
      yourAccessCode: "Código de acesso.",
      typeYourAccessCode: "Digite o código de acesso...",
      privacyPolicy: "Política de Privacidade",
      allRights: "Todos os direitos reservados",
      checkYourEmail: "Confira o seu e-mail",
      confirmationEmail: "O e-mail de confirmação e processo de alteração de senha foi enviado para o seu e-mail.",
      didntRecieved: "Você não recebeu o e-mail?",
      clickHereToResend: "Clique aqui para reenviar.",
      alrightUnderstand: "Certo, entendi",
      qrcodeTitle: "QR code gerado",
      qrcodeSub: "Escaneie o qrcode abaixo para configurar a sua aplicação.",
      otpTittle: "Senha uso único.",
      otpSub: "Coloque o código já obtido em seu autenticador.",
      OtpMessage: "Senha de uso único.",
      qrcodeRedirect: "Após escanear o qrcode, clique no botão para inserir sua senha de uso único.",
      oneUsePassword: "Colocar a senha de uso único.",
      otpErrorMessage: "Senha de uso único necessária",
      error: "Problema no login",
      oneTimePasswordError: "A sua senha de uso único não foi aceita, tente novamente.",
      oneTimePasswordSucess: "Sua senha de uso único foi aceita com sucesso.",
      microsoft: "Continue com",
      confirm: "Confirmar"
    },
    InvalidCaptcha: {
      message: "Captcha inválido"
    },
    Reset: {
      message: "Resetado com sucesso.",
    },
    ResetPasswordSuccess: {
      title: "Senha alterada com sucesso",
      subtitle: "A sua senha foi alterada com sucesso, lembre-se de guardá-la com segurança. Clique no botão abaixo para acessar o login."
    },
    AutoArquivar: {
      message: "Auto Arquivar"
    },
    ParaArquivar: {
      message: "Para arquivar"
    },
    Temporality: {
      message: "Temporalidade",
      subtitle: "Acompanhe prazos e status com clareza, analisando a evolução temporal para uma melhor gestão e tomada de decisões.",
      panelTitle: "Adicionar Temporalidade",
      dateTemp: "Auto Arquivar em:",
      select: "Selecionar Temporalidade",
      descriptionTemporalityMenu: "Selecione um dos workspaces abaixo para visualizar o relatório de temporalidade.",
      Expired: "Vencido",
      Filed: "Arquivado",
      Signed: "Assinado",
      Removed: "Removido",
      AppliedFilters: "Filtros aplicados",
      ClearFilters: "Limpar filtros",
      FilterByStatus: "Filtrar por",
      ToolTipMessage: "O status define o estado, posicionamento ou situação do documento no processo em que se encontra.",
      Name: "Nome",
      DeadlineStatus: "Status de vencimento",
      Deadline: "Vencimento",
      Apply: "Aplicar",
      Content: "Configure um prazo de vencimento ou retenção para documentos. A regra será aplicada conforme os critérios definidos abaixo.",
      NotifyDeadline: "Notificar alerta",
      NotifyDeadlineContent: "Defina com quanta antecedência você deseja ser notificado sobre o vencimento deste documento.",
      Quantity: "Quantidade (dias)",
      DaysAdvance30: "30 dias antes",
      DaysAdvance7: "7 dias antes",
      DaysAdvance1: "1 dia antes",
      DealineDay: "No dia do vencimento",
      Custom: "Personalizado",
      FilterByDate: "Filtrar por data",
      DeadlineOptions: {
        NearDeadline: "Próximo ao vencimento",
        BelowDeadline: "Dentro do prazo",
        AboveDeadline: "Vencido"
      }
    },
    TemporalityComboBox: {
      ExplanatoryText: "Alterar status para",
      TooltipHostDefalt: "O status define o estado, posicionamento ou situação do documento no processo em que se encontra.",
      TooltipHostExpired: 'O status "Vencido" irá definir que o prazo acabou para executar alguma ação relacionada com o documento selecionado.',
      TooltipHostArquived: 'O status "Arquivado" irá guardar e inativar o documento. O mesmo pode ser ativo e retomado novamente a qualquer momento.',
      TooltipHostDraft: 'O status "Draft" é definido como rascunho, ou seja, o item se encontrará em estado inicial e precisará passar por uma nova validação.',
      PlaceHolder: "Selecione"
    },
    dataArqchive: {
      message: "Data de Arquivamento"
    },
    WithoutRule: {
      withoutRule: "Sem regra",
      withoutDesc: "Sem descrição"
    },
    ViwerInfo: {
      cannotView: "Não é possível visualizar este arquivo",
      notPreview: "O arquivo que você está tentando visualizar não possui visualização para leitura. Para conseguir visualizá-lo, clique no botão abaixo para fazer download e acesse o arquivo.",
      downloadFile: "Download do arquivo"
    },
    DataTableHeaders: {
      Reviews: "Revisões",
      Actions: "Ações",
      Users: "Usuários",
      Date: "Data criação",
      DueDate: "Vencimento",
      Name: "Nome",
      Description: "Descrição",
      ExplanatoryText: "Data em que a ação será executada",
      TooltipHost: "O vencimento define o tempo de validade de um documento.",
    },
    FilterTables: {
      OrdenationDate: "Ordem data",
      Reviews: "Revisões",
      AlphaOrder: "Ordem alfabética",
      OrderByUsers: "Ordenar por usuários",
      OrderByMessages: "Ordenar por mensagens",
      Descending: "Decrescente",
      Ascending: "Crescente",
      apply: "Aplicar",
      clearFilters: "Limpar filtros"
    },
    DetailPhLocation: {
      TypeHereLocal: 'Digite aqui... (Ex.: Sala, Prédio, Andar)',
      TypeHereBookcase: 'Digite aqui... (Ex.: Estante verde, Estante n° 3)',
      TypeHereShelf: 'Digite aqui... (Ex.: Prateleira n° 3, Quarta prateleira de cima para baixo)',
      TypeHerePosition: 'Digite aqui... (Ex.: Caixa vermelha, Arquivo em cima da mesa)',
      TypeHereAdditionalInformation: 'Digite aqui...',
      SaveButton: "Salvar alterações",
      CancelButton: "Cancelar alterações"
    },
    UnableToReturnItemTemporality: {
      message: "Incapaz de devolver a Temporalidade do Item"
    },
    SelectTemporality: {
      message: "Selecionar Temporalidade"
    },
    SelectDocumentExpiration: {
      message: "Selecionar Validade do Documento"
    },
    DocumentValidity: {
      message: "Validade do documento"
    },
    Validity: {
      message: "Validade"
    },
    EmptyTemporalityField: {
      message: 'Campo de temporalidade vazio'
    },
    EmptyDocumentValidityField: {
      message: 'Campo de validade do documento vazio'
    },
    RetroactiveDueDate: {
      message: 'Vencimento retroativo'
    },
    HasExpired: {
      message: 'Expirou'
    },
    Option: {
      message: "Definir status como"
    },
    RemoveTemporality: {
      message: "Remover temporalidade"
    },
    Reload: {
      message: "Recarregar"
    },
    AssignServiceUser: {
      message: "Atribuir usuário de serviço"
    },
    ErrorReceivingAdminUsers: {
      message: "Erro ao receber Usuários administradores"
    },
    Dashboard: {
      general: "Geral",
      storageLimit: "O seu limite de armazenamento é de",
      generalDataUsage: "Uso de dados geral",
      storageInUse: "Espaço em uso",
      freeStorage: "Espaço livre",
      wsDataUsage: "Uso de dados em workspaces",
      storageUseWithoutContract: "Sem máximo cadastrado",
      OrganizationDoesntHaveWorkspace: "Organização não há nenhum Workspace.",
      storagePerUser: "Armazenamento por usuário",
      notFoundgeneralData: "Dados indisponíveis no momento.",
      AllUsers: "Todos os usuários",
      Users: "Usuários",
    },
    UpgradeCard: {
      needUpgrade: "Precisa de um ",
      upgradeSpace: "upgrade de espaço?",
      wantUpgrade: "Quero um upgrade"
    },
    StorageTypeFile: {
      documents: "Documentos",
      images: "Imagens",
      videos: "Vídeos",
      others: "Outros"
    },
    FilterRangeUsageStorage: {
      buttonFilter: "Filtro",
      title: "Uso de armazenamento",
      greaterThan: "Maior que",
      lessThan: "Menor que",
      clear: "Limpar",
      apply: "Aplicar",
      valueCannotBeNegative: "O valor não pode ser negativo."
    },
    Dwg: {
      size: "Tamanho",
      palette: "Paleta",
      orientation: "Orientação",
      converterType: "Tipo de conversor",
      backgroundColor: "Cor de fundo",
      title: "Selecione as opções abaixo para vizualizar o arquivo"
    },
    Selecionar: {
      message: "Selecionar"
    },
    YourBrowserDoesNotSupportThePrintingFunction: {
      message: "Seu navegador não suporta a função de impressão."
    },
    ChooseColumns: {
      message: 'Escolher colunas',
      description: 'Descrição',
      validationRule: 'Regra de Validação',
      term: 'Prazo',
      size: 'Tamanho',
      createdAt: 'Criado em',
      applyFilter: "Aplicar filtro",
      reset: "Resetar"
    },
    FilterBy: {
      message: "Filtrar por status",
      toolTipMessage: "O status define o estado, posicionamento ou situação do documento no processo em que se encontra.",
      placeholderMessage: "Selecione..."
    },
    NoRegistry: {
      title: "Nenhum filtro selecionado",
      message: "Selecione um vencimento e um status para realizar a sua busca."
    },
    WorkspaceItemFlowListing: {
      responsible: "Responsável",
      date: "Data",
      progress: "Em andamento",
      waiting: "Aguardando...",
      by: "Por",
      dynamic: "Responsavel dinâmico"
    },
    OrganizationMessages: {
      "problemWithResources": "Problema ao recuperar recursos.",
      "resourceAlert": "Contrato não possui recurso de chamada de Api."
    },
    ErrorViwer: {
      title: "Não foi possível visualizar este arquivo",
      description: "Ocorreu um problema ao carregar a visualização. Tente novamente mais tarde."
    },
    ViwerAutomaticDwg: {
      message: "Gerar dados de visualização de cad em background"
    },
    DuplicateFolder: {
      message: "Duplicar pasta"
    },
    NameMustNotIncludeEitherSlashes: {
      message: "Nome não deve incluir \\ ou /"
    },
    MaintainPermissions: {
      message: "Manter permissões"
    },
    DuplicationOf: {
      message: "Duplicação de"
    },
    CopyDocumentLink: {
      message: "Copiar link do documento",
    },

    ItemIdNotFound: {
      message: "Id do item não encontrado",
    },
    WithoutPermission: {
      message: "Sem permissão",
    },
    RecicleBin:{
      title: "Lixeira",
      subtitle: "Mantenha o controle: Restaure ou remova permanentemente arquivos da lixeira.",
      fileName: "Nome do Arquivo",
      userName: "Responsável",
      date: "Data de exclusão",
      confirm: "Confirmar",
      restore: "Restaurar",
      to: "para",
      search: "Busca...",
      folder: "Pasta",
      fileRestored: "Arquivo restaurado",
      goToFileFolder: "Ir para pasta do arquivo",
      finishAndClose: "Concluir e fechar",
      deletedSuccessTitle: "Remoção realizada com sucesso!",
      deletedSuccessHeader: "Confira abaixo os itens que foram excluídos definitivamente.",
      emptyRecycleBinPartA:"Lixeira vazia",
      emptyRecycleBinPartB:"Parece que finalmente alguém tirou o lixo para fora.",
      emptyRecycleBinPartC:"Não há arquivos ou pastas por aqui.",
      emptyRecycleBinPartD:"Não há pastas por aqui",
      selectOneWorkspace:"Selecione um Workspace para visualizar pastas.",
      deleteConfirm: "Confirme se você realmente gostaria de remover definitivamente o arquivo",
      deleteConfirmTwo: "Assim que removido, não será possível recuperá-lo.",
      deleteTitleList: "Você deseja remover todos os itens?",
      deleteConfirmList: "Confirme se você realmente gostaria de remover definitivamente todos os itens citados abaixo. Assim que removido, não será possível recuperá-lo.",
      cancel: "Cancelar",
      deleteSelected: "Remover arquivos",
      restoreListButton: "Restaurar arquivos",
      restoreTitleConfirm:"Você deseja restaurar o arquivo?",
      restoreTitleConfirmList: "Restaurar todos os itens?",
      restoreConfirmList: "Confirme se você realmente gostaria de restaurar todos os itens citados abaixo. E por fim, defina o destino de armazenamento.",
      deleteModalTitle: "Você deseja remover o arquivo?",
      headerRestorePartA:"Para restaurar o arquivo",
      headerRestorePartB:"defina o destino de",
      headerRestorePartC:"armazenamento.",
      headerRestoreLastConfirmation:'Verifique as informações de restauração abaixo e confirme se o caminho de restauração está correto. Se incorreto, clique em "Cancelar".',
      headerRestoreSuccessTitle:"Arquivo restaurado com sucesso!",
      headerRestoreSuccessPartA:"O arquivo",
      headerRestoreSuccessPartB:"foi restaurado com sucesso. Confira abaixo as",
      headerRestoreSuccessPartC:"informações para encontrá-lo após a restauração.",
      removedBy: "Removido por",

      filter: "Filtros",
      files: "Arquivos",
      select:"Selecione...",
      viewMyFiles:"Ver meus arquivos",
      seeAllFiles:"Ver todos os arquivos",
      current: "(Atual)",
      defalt: "(Padrão)",
      reset: "Resetar",
      applyFilter: "Aplicar filtro",

      compareFiles: "Comparar arquivos",
      ignoreFiles: "Ignorar arquivos",
      replaceFiles: "Substituir arquivos",
      compareFile: "Comparar arquivo",
      ignoreFile: "Ignorar arquivo",
      replaceFile: "Substituir arquivo",
      CheckItemsSameNameTitle: "Há itens já existentes no destino",
      headerCheckItemsSameNamePartA: "O destino já possui ",
      headerCheckItemsSameNamePartB: " itens/arquivos",
      headerCheckItemsSameNamePartC: "com os mesmos nomes. Selecione",
      headerCheckItemsSameNamePartD: "abaixo qual ação você gostaria de realizar.",

      compareFilesTitle: "Compare os arquivos e escolha um deles",
      headerCompareFiles: "Compare os arquivos abaixo para decidir qual versão você deseja manter.",
      compareFilesTitleList: "Item em",

      restoreSuccessListTitleType1: "Substituição e restauração realizadas com sucesso!",
      restoreSuccessListTitleType2: "Arquivos ignorados e restauração realizada com sucesso!",
      restoreSuccessListTitleType3: "Itens atualizados com sucesso!",
      headerRestoreSuccessListType1PartA: "A substituição e a restauração dos itens foram concluídas com sucesso. Veja",
      headerRestoreSuccessListType1PartB: "abaixo a lista dos arquivos e pastas restauradas.",
      headerRestoreSuccessListType2PartA: "A restauração foi concluída. Arquivos com nomes duplicados foram",
      headerRestoreSuccessListType2PartB: "ignorados. Veja abaixo a lista dos arquivos e pastas restauradas.",
      headerRestoreSuccessListType3PartA: "Os itens selecionados foram atualizados com sucesso. Confira abaixo a lista",
      headerRestoreSuccessListType3PartB: "com os itens atualizados.",

      selectedListTooltipText: "Abrir em nova aba",
      deleteConfirmTooltipText: "Remover arquivo definitivamente",
      restoreConfirmTooltipText: "Restaurar arquivo da lixeira"
    },
    NotFoundPage:{
      header: "Página não encontrada",
      body: "Infelizmente a página que você tentou acessar não foi encontrada.",
      button: "Voltar para Início",
    },
    LoggedHome: {
      QuickAccessContent: "Salve os seus caminhos e arquivos que você utiliza diariamente e consiga acessá-los rapidamente por aqui ou de onde você estiver.",
      QuickAccessTitle: "Acesso rápido",
      OrganizationsContent: 'Os workspaces mais visitados ou favoritados estão disponíveis logo abaixo. Para visualizar todos, clique em "Workspaces".',
      OrganizationsTitle: "Organizações",
      RecentActivities: "Atividades recentes",
      RecentActivitiesContent: 'Tenha acesso às atividades realizadas recentemente. Para visualizar todas, clique em "Atualizações".',
      FileName: "Nome do arquivo",
      Action: "Ação",
      Responsible: "Responsável",
      LastModification: "Última modificação",
      favoriteSuccess: "favoritado com sucesso.",
      favoriteExclude: "Favorito deletado.",
      favoriteError: "favorite já existente.",
      NoRecentActivities: "Não há atividades recentes",
      MovingOrganization: "Comece a movimentar a sua organização por meio dos workspaces. Com isso, você irá visualizar as atividades por aqui.",
      ViewMore: "Ver lista completa"
    },
    Favorite: {
      SuccessFavorite: "Seu item foi favoritado com sucesso. Você poderá vê-lo no acesso rápido em breve",
      FailureFavorite: "Não foi possivel favoritar seu item. Verifique se ele já não é favoritado. Se o erro persistir, acione o suporte",
      RemoveFavoriteSuccess: "Seu item foi removido dos favoritos com sucesso. Ele não aparecerá mais no acesso rápido",
      RemoveFavoriteFailure: "Não foi possível remover seu item dos favoritos. Verifique se ele já não foi removido. Se o erro persistir, acione o suporte"
    },
    Minicard: {
      File: "Arquivo",
      Folder: "Pasta",
      Desfav: "Remover favorito",
      fav: "Favoritar",
      NothingViewMiniCardTitle: "Não há itens salvos",
      NothingViewMiniCardContent: "Nenhum item foi salvo até o momento.",
      NothingViewMiniCardWorkspaceTitle: "Nenhum workspace criado até o momento.",
      MiniCardAllFavoritesTitle: "Todos os workspaces favoritados até o momento",
      MiniCardAllFavoritesContent: "Todos os seus workspaces estão favoritados",
      NothingViewMiniCardWorkspaceContent: "Nenhum workspace salvo até o momento.",
      NothingViewMiniCardWorkspaceTitleAdm: "Nenhum workspace criado até o momento",
      NothingViewMiniCardWorkspaceContentAdm: "Esta organização ainda não possui workspaces. Comece criando um por aqui!"
    },
    LogErrors: {
      browser: "Navegador",
      errorFound: "Erro Encontrado",
      createdDate: "Data de Criação",
      server: "Servidor",
      method: "Método",
      stackTrace: "Rastreamento de Pilha",
      userMail: "Email do Usuário",
      line: "Linha",
      search: "Buscar..."
    },
    FileNotFound: {
      message: "Arquivo não encontrado"
    },
    Divider: {
      message: "ou"
    },
    Navbar: {
      placeholderImputText: "O que você está procurando...",
      labelCheckbox: "Somente nesta pasta"
    },
    ShareFileComp: {
      share: "Compartilhar",
      firstTitle: "Para compartilhar o item abaixo com outros usuários, preencha os campos abaixo conforme as necessidades do compartilhamento.",
      advancedOptions: "Opções avançadas",
      hasWatermark: "Contém marca d'água",
      sharetilDate: "Compartilhar até a data",
      limitAccess: "Limitar quantidade de acesso",
      dontLimitAccess: "Compartilhar sem expirar o acesso",
      shareWith: "Compartilhar com",
      back: "Voltar",
      textWord: "Texto (Palavra)",
      orientation: "Orientação",
      SaveWatermark: "Salvar marca d'água",
      editWatermark: "Editar marca d'água",
      shareSuccess: "Compartilhamento de arquivo efetuado com sucesso",
      typeHere: "Digite aqui...",
      text: "Texto",
      noWatermark: "Sem marca d'água",
      limitAccessTooltip: "A quantidade de acessos é contabilizada por compartilhamento. Após atingir o limite definido, o arquivo ficará indisponível para os demais usuários"
    },
    Snackbar: {
      success: "Sucesso!",
      atention: "Atenção!",
      error: "Erro!",
      information: "Informação!"
    },
    BatchActionModal: {
      actionLabel: "Ações em documentos",
      actionSublabel: "Veja os documentos aprováveis e não aprováveis de acordo com as ações em lote.",
      batchAprovable: "Aprováveis em lote",
      nonBatchAprovable: "Não aprováveis",
      documentName: "Nome do documento",
      reproveButton: "Reprovar documentos",
      aproveDocument: "Aprovar documentos",
      approvedDocuments: "Documentos aprovados com sucesso!",
      approvedDocumentsSub: "Os documentos listados abaixo foram aprovados com sucesso.",
      concluded: "Concluir",
      reprovedDocuments: "Documentos reprovados com sucesso!",
      reprovedDocumentsSub: "Os documentos listados abaixo foram reprovados com sucesso."
    },
    Sidebar: {
      QuickAccess: "Acesso Rápido",
      Home: "Início",
      Dashboard: "Dashboard",
      Feed: "Atualizações",
      Groups: "Grupos",
      Pendencies: "Pendências",
      Users: "Usuários",
      Documents: "Documentos",
      ValidationRules: "Regras de Validação",
      Temporality: "Temporalidade",
      Preferences: "Preferências",
      CloseSidebar: "Minimizar Sidebar",
      Organizations: "Organizações",
      Privileges: "Privilégios"
    },
    MigrationsTab: {
      Migrations: "Migrações",
      NotMigrationsPending: "Não há migrações pendentes",
      MigrationsPendingContent: "Quando houver migrações pendentes, elas aparecerão aqui.",
      UserEmail: "Email do usuário",
      IdSubscription: "ID da assinatura",
      Actions: "Ações",
      NameUser: "Nome do usuário",
      AceptMigration: "Aceitar migração",
      DeclineMigration: "Recusar migração",
    },
    PlanCheckout: {
      PlanCheckoutContent:"Seu plano foi contratado em sua conta. Para acessá-la, retorne à pagina de login e preencha os campos com as informações cadastradas.",
      PlanCheckoutTitle:"Plano contratado com sucesso!"
    },
    Register: {
      NullOrg: "Organização não pode ter nome vazio",
      OrgName: "Nome da organização",
      PassNull: "Senhas não podem ser vazias",
      Password: "Senha",
      ConfirmPassword: "Confirmar senha",
      TypeHere: "Digite aqui...",
      Minimun8: "Minimo de 8 caracteres",
      AnUpperCaseLetter: "Um caracter maiusculo",
      ASpecialLetter: "Um caracter especial",
      Numeric: "Um caracter numérico",
      PasswordMatch: "Senhas coincidem",
      FirstPageError: "Campos devem ser preenchidos de maneira correta.",
      Username: "Nome de usuário",
      Email: "E-mail",
      WantSendingEmail: "Quero receber e-mails com atualizações importantes e avisos da plataforma.", 
      IamOkPrivacy: "Concordo com os Termos de Serviço e a Política de Privacidade",
      BackToLogin: "Voltar para login",
      AlreadyHaveAccount: "Já possui conta? ",
      BeOkWithBoth: "Você precisa concordar com nossas políticas e recebimento de emails."
    },
      OrganizationConfig: {
      OrganizationInformation: "Informações da Organização",
      Name: "Nome",
      Save: "Salvar",
      Cancel: "Cancelar",
      ServiceUser: "Usuário de serviço",
      Select: "Selecione...",
      ElectronicSignature: "Assinatura eletrônica",
      SuccessfullyEdited: "Editado com sucesso",
      SuccessfullyChanged: "Alterado com sucesso",
      NameEdited: "Nome da organização editado com sucesso.",
      SomethingWentWrong: "Algo deu errado",
      ChangesCanceled: "Alterações canceladas",
      OrganizationNotFound: "Organização não encontrada",
      ErrorGettingSafe: "Erro ao buscar cofre"
    },
    AdminConsole: {
      UsersAddedSuccessFullyTitle: "Usuário(s) adicionado(s) com sucesso!",
      UsersAddedPartialTitle: "Usuário(s) adicionado(s) com inconsistências",
      UsersCannotbeAddedTitle: "Não foi possivel adicionar usuários.",
      OrganizationNameNotNull: "Nome da organização não pode ser vazio",
      UsersAddedSuccessfully: "usuários adicionados com sucesso",
      NewUserBatch: "Adicionar usuário em lote",
      UsersCannotBeAdded: "usuários não puderam ser adicionados",
      Organization: "Organização",
      OrganizationContent: "Gerencie as informações gerais da organização, incluindo dados administrativos, membros, permissões e configurações da conta.",
      OrganizationPageContent: "Encontre as organizações que você tem acesso na listagem abaixo.",
      NotSelectedOrganization: "Organização não selecionada",
      NotSelectedOrganizationContent: "Escolha uma organização para consultar informações e recursos disponíveis.",
      OrganizationWorkspaceContent: 'Encontre aqui as seções que a equipe colabora com o compartilhamento de arquivos.',
      OrganizationNameLabel: "Nome da organização",
      OrganizationDescriptionLabel: "Descrição da organização",
      ExcludeOrg: "Excluir organização",
      ExcludeOrgContent: "Ao excluir esta organização, todos os workspaces, arquivos, usuários e configurações associados serão removidos permanentemente. Esta ação não poderá ser desfeita.",
      OrgnizationDeleteText: "Confirme se você quer excluir a organização selecionada",
      OrganizationDeleteTitle: "Excluir a organização?",
      OrganizationCreateText: "Informe um nome para identificar a nova organização.",
      OrganizationCreateTitle: "Nova organização",
      OrganizationInformation: "Informação da organização",
      SeeAllWorkspaces: "Clique para ver todos os workspaces",
      AddUserSubtitle: "Adicione usuários e defina a função de cada membro dentro da organização.",
      InfomationNeeds: "Informações necessárias",
      Username: "Nome de usuário",
      ClearAll: "Limpar tudo",
      SetUserAdminSystem: "Adicionar Usuário como administrador do sistema",
      UnSetUserAdminSystem: "Remover usuário como administrador do sistema",
      SetUserAdmin: "Renomear usuário como administrador",
      UnSetUserAdmin: "Remover usuário como administrador",
      ClearSelect: "Limpar seleção",
      Preferences: {
        Title: "Preferências",
        SubTitle: "",
        OrgInfo: "Informações da organização",
        OrgPreferences: "Preferências da organização",
        OrgPreferencesSub: "Aqui você encontra as configurações gerais que valem para toda a organização.",
        Storage:"Armazenamento",
        AllowDrive: "Atribuir permissão para o drive",
        D4sign: "Assinatura eletrônica",
        Refresh: "Atualizar",
        Delete: "Excluir",
        Save: "Salvar",
        UserService: "Usuário de serviço"
      },
      GuestUserTitle: "Usuário será adicionado como convidado",
      later: "Decidir mais tarde",
      GuestUserContent: "O usuário que pretende adicionar já possui uma assinatura ativa, ele será adicionado à sua organização como um usuário convidado.",
      Hello: "Olá,",
      TestUser: " Usuário Teste!",
      User: "Usuário",
      HereYouHaveAccessToYour: "Aqui você tem acesso ao seu",
      AdminPanel: " painel de administrador,",
      YouWillFindAllTheToolsYouNeedToManageYourSubscription: " você encontrará todas as ferramentas necessárias para o gerenciamento da sua assinatura.",
      AccountAndSubscription: "Conta e Assinatura",
      ManageYourAccountAndSubscriptionEnsuringFullControlOverImportantSettings: "Administre sua conta e assinatura, garantindo controle total sobre configurações importantes.",
      FollowRealTimeUpdatesAndNotificationsToStayInformedAboutImportantActivities: "Acompanhe atualizações e notificações em tempo real para se manter informado sobre atividades importantes.",
      UsersAndGroups: "Usuários e Grupos",
      EfficientlyLearnAboutUsersAndGroupsToFacilitateCollaborationAccessControlAndPermissions: "Saiba sobre usuários e grupos com eficiência para facilitar colaboração, controle de acesso e permissões.",
      CheckOutAndManageOrganizationsViewingDetailsLikeStorageAndSettings: "Confira e gerencie organizações, vendo detalhes como armazenamento e configurações.",
      BrowseTheAvailablePlansCompareFeaturesAndChooseTheBestOptionForYourNeeds: "Consulte os planos disponíveis, compare recursos e escolha a melhor opção para sua necessidade.",
      SEEMORE: "VER MAIS",
      ReturnToAccount: "Retornar para Conta",
      NeedToTalkToSupport: "Precisa falar com o suporte?",
      ContactOurSupportTeamByClickingTheButtonBelow: "Entre em contato com nossa equipe de suporte clicando no botão abaixo.",
      GetInContact: "Entre em contato",
      Users: "Usuários",
      Groups: "Grupos",
      Privileges: "Privilégios",
      Privilege: "Privilégio",
      WhatAreYouLookingFor: "O que você está procurando...",
      NewUser: "Novo usuário",
      NewGroup: "Novo grupo",
      Name: "Nome",
      GroupName: "Nome do grupo",
      Phone: "Telefone",
      GuestUserAdd: "Novo convidado",
      GuestUserSnackMessage: "Usuário convidado adicionado com sucesso!",
      Participants: "Participantes",
      EditInfo: "Editar informações",
      Save: "Salvar",
      Cancel: "Cancelar",
      Back: "Voltar",
      UsersInfo: "Informações do usuário",
      GroupsInfo: "Informações do grupo",
      AvailableGroups: "Grupos disponíveis",
      LoginWithTwoFa: "Login com autenticação de dois fatores",
      EnableTwoFa: "Ative esta opção para permitir que o usuário faça login no sistema utilizando autenticação de dois fatores.",
      AllowTwoFa: "Permitir login com autenticação de dois fatores.",
      TypeUserName: "Digite aqui o nome do usuário...",
      TypeUserEmail: "Digite aqui o e-mail do usuário...",
      TypeUserPhone: "Digite aqui o telefone do usuário...",
      AddUser: "Adicionar usuário",
      NoUsers: "Nenhum usuário adicionado",
      Owner: "Proprietário",
      Administrators: "Administradores",
      AddUsersToGroup: "Preencha o campo acima e adicione usuários ao grupo.",
      Select: "Selecione...",
      UsersMin: "usuários",
      GroupsMin: "grupos",
      TypeGroupName: "Digite aqui o nome do grupo...",
      Showing: "Mostrando",
      Total: "totais",
      Of: "de",
      MeAnd: "@Eu e",
      UsersParticipates: "Usuários participam",
      DisableModalTitle: "Você deseja desativar o usuário?",
      ConfirmIfYouReallyWantToDisableSelectedUser: "Confirme se você realmente gostaria de desativar o usuário selecionado.",
      InvalidUsername: "Insira ao menos 3 digitos.",
      InvalidEmail: "O e-mail inserido não é válido.",
      InvalidPhone: "Digite 11 digitos ou nenhum",
      DisableGroupModalTitle: "Você deseja excluir o grupo?",
      DialogDeleteGroupStart: "Confirme se você realmente gostaria de excluir definitivamente o grupo",
      DialogDeleteGroupEnd: "Assim que removido, não será possível recuperá-lo.",
      UserRemovedFromGroup: "Usuário removido do grupo",
      DisableGroup: "Desativar grupo",
      GroupCreated: "Grupo criado com sucesso",
      Organizer: "Organizador",
      Validator: "Validador",
      Reader: "Leitor",
      RootSubtitle: "Tem acesso completo a todas as funcionalidades do sistema, incluindo a criação e gerenciamento de pastas e documentos, entre outras opções.",
      OwnerSubtitle: "Permite realizar edições na ferramenta e acessar suas funcionalidades. No entanto, não é possível criar ou excluir estruturas de pastas.",
      OrganizerSubtitle: "Não possui acesso a privilégios administrativos e não pode alterar a pasta raiz, mas pode criar novas subpastas e documentos, além de editar e excluir conteúdos existentes. As subpastas herdarão automaticamente os mesmos privilégios dos grupos e usuários da pasta raiz.",
      EditorSubtitle: "Realiza edições na ferramenta e tem acesso as funcionalidades. Não pode criar e excluir estruturas de pastas.",
      ValidatorSubtitle: "Permite consultar, visualizar e fazer o download de documentos. Também oferece funcionalidades para aprovar e assinar documentos.",
      ReaderSubtitle: "Estes usuários apenas consultam e visualizam os documentos nos Workspaces permitidos.",
      ResetPasswordEmail: "Email para redefinição de senha enviado",
      RemoveGroup: "Remover do grupo",
      DisableUser: "Desativar usuário",
      EditUserInfo: "Editar informações",
      ResetPassword: "Resetar Senha",
      DoesNotHave: "Não possui",
      WorkspaceSubtittle: "Aqui você consegue visualizar todos os Workspaces existentes nesta Organização.",
      NewWorkspace: "Novo workspace",
      NotFoundWorkspace: "Não há Workspaces ainda",
      NoFoundWorkspaceSubtittle: "Junte-se ou crie um workspace e após, a área de trabalho irá aparecer disponível aqui.",
      NoDescription: "Sem descrição",
      UsersWithAccess: "Usuários com acesso",
      Documents: "Documentos",
      NewWorkspaceTitle: "Novo Workspace",
      UpdateWorkspaceTitle: "Editar Workspace",
      CreateWorkspace: "Criar Workspace",
      UpdateWorkspace: "Editar Workspace",
      CreatingYourWorkspace: "Estamos configurando seu Workspace. Por favor, aguarde um momento.",
      UpdateYourWorkspace: "Estamos atualizando seu Workspace. Por favor, aguarde um momento.",
      CreatingWorkspace: "Criando Workspace",
      UpdatingWorkspace: "Atualizando workspace",
      CreatingYourWorkspaceDialog: 'O Workspace foi criado com sucesso! Clique em "Continuar" para visualizar a lista de Workspaces e acessá-los.',
      WorkspaceQuantityNotAllowedTitle: 'Não é possível criar mais workspaces.',
      WorkspaceQuantityNotAllowedContent: 'O limite de workspaces permitido para o seu plano já foi atingido. Para criar mais workspaces, entre em contato com o suporte ou acesse a página de planos para realizar um upgrade.',
      ReturnToWorkspacePage: 'Retornar à página de Workspaces',
      UpdateYourWorkspaceDialog: 'O Workspace foi atualizado com sucesso! Clique em "Continuar" para visualizar a lista de Workspaces e acessá-los.',
      CreatingYourWorkspaceDialogTitle: 'Tudo pronto',
      CancelSubscriptionDialogTitle: 'Tem certeza que deseja cancelar sua assinatura?',
      Duplicate: "Duplicar",
      Edit: "Editar",
      Favorite: "Favoritar",
      Unfavorite: "Remover favorito",
      Delete: "Deletar",
      Confirm: "Confirmar",
      Continue: "Continuar",
      DeleteDialogTextPart1: 'Confirme se você realmente gostaria de excluir definitivamente o Workspace ',
      DeleteDialogTextPart2: "Assim que removido, não será possível recuperá-lo.",
      DeleteDialogTitle: "Você deseja excluir o Workspace?",
      WorkspaceName: "Nome do workspace",
      ValidationWorkspaceName: "Nome deve ter 3 ou mais characteres",
      WorkspaceDescription: "Descrição do workspace",
      Rules: "Regras",
      UploadAsRealease: "Upload com release",
      CadBackground: "Gerar dados de visualização de arquivos .CAD em background",
      PrivilegeFollow: "Privilégios na raiz do workspace serão herdados pelas pastas (inclusive alterações)",
      NoUsersInWorkspace: "Nenhum usuário adicionado",
      NoUsersInWorkspaceSub: "Preencha o campo acima e adicione usuários ao grupo.",
      TheWorkspaceDoesNotHaveAnyLinkedUsersYet: "Workspace ainda não possui usuários vinculados.",
      CommonUsers: "Comum",
      ReadUsers: "Leitor",
      EditUsers: "Editor",
      ViewUsers: "Visualizador",
      OrganizeUsers: "Organizador",
      SeeAll: "Ver todos",
      ClientInformation: "Informações do Cliente",
      Company: "Empresa",
      Responsible: "Responsável",
      ResponsiblePersonEmail: "E-mail de responsável",
      CellPhone: "Celular",
      ContractInformation: "Informações do Contrato",
      ContractNumber: "Número do contrato",
      TermOfTheContract: "Vigência do contrato",
      TotalContractValue: "Valor total do contrato",
      Organizations: "Organizações",
      Server: "Servidor",
      Category: "Categoria",
      Storage: "Armazenamento",
      LoginWithOffice365: "Login com Office 365",
      DescriptionLoginWithOffice365: "Esta opção permite ao usuário realizar o login no sistema utilizando a sua conta da Microsoft.",
      AllowsLoginWithOffice365: "Permite login com Office 365",
      ContactOurSupportTeamByClickingTheButtonNextToIt: "Entre em contato com nossa equipe de suporte clicando no botão ao lado.",
      NoExistingContract: "Nenhum contrato existente",
      DescriptionNoExistingContract: "Parece que nenhum contrato foi criado até o momento.",
      Plans: "Planos",
      Group: "Grupo",
      FreeTier: {
        FreeTitle: "Você está usando a versão gratuita do sistema",
        FreeContent: "Assine um de nossos planos para ter acesso às abas administrativas.",
        AccessPlans: "Ver Planos"
      },
      ErrorContract: "Houve um erro envolvendo a recuperação do seu contrato e já estamos resolvendo. Se o problema persistir, contate o suporte.",
      ErroContractTitle: "Houve um erro",
      DashboardSubtitle: "Acompanhe dados e métricas essenciais de forma intuitiva para otimizar decisões e monitorar o desempenho com eficiência.",
      RedirectToHomeOnContinue: "Ao clicar em Continuar, a alteração será efetuada e a página será automaticamente atualizada. Deseja continuar?",
      AddBatchUser: {
        NoUsersAddedTitle: "Não há usuários",
        NoUsersAddedContent: "Nenhum usuário foi adicionado até o momento",
        UsersAdded: "Usuários adicionados",
        SelectUserToSelectOrg: "Selecione um usuário para poder selecionar uma organização",
        UserAlreadyAdded: "Usuário(s) já adicionado(s)",
        UserAlreadyAddedContent: "Este usuário já foi adicionado.",
        NameAbove50Chars: "Nome de usuário não pode ultrapassar 50 caracteres",
        EmailInvalid: "Email inválido",
        UserAddedBatch: "Usuários adicionados em lote",
        UserAddedBatchContent: "Se um workspace for selecionado para adição, aquele usuário será adicionado como comum"
      }
    },
    Security: {
      AdminAccessDeniedTitle: "Acesso Restrito - Administrador",
      AdminAccessDeniedMessage: "Por questões de segurança e conformidade com a LGPD, administradores do sistema não têm acesso a páginas contendo dados sensíveis de pagamento e informações pessoais dos usuários. Esta restrição protege a privacidade dos dados e garante o princípio do privilégio mínimo."
    },
    AccountAndSubscription: {
      RecoverySubscription: "Recuperar assinatura",
      CanceledSubscriptionCaption: "Sua assinatura está cancelada. Para mais detalhes chame o suporte.",
      IdInvoice: "Identificador da fatura",
      Username: "Email de usuário",
      StatusInvoice: "Status da fatura",
      CancelSubscription: "Cancelar assinatura",
      ClientServices: "Serviços do cliente",
      Others: "Outros",
      NoFeatures: "Features não existentes",
      SwitchServices: "Vou trocar de serviço",
      AddCancelComments: "Adicione comentários para que possamos melhorar nosso software",
      RecoverySubscriptionDialogContent:  "Recupera a sua assinatura cancelada clicando no botão de recuperar. Seus itens assinados serão mantidos e você poderá utilizar o software normalmente. (Será recuperado o MESMO plano contratado e a cobrança será automática.)",
      CancelSubscriptionMotivate: "Por qual motivo deseja cancelar sua assinatura?",
      Payment: "Pagamento",
      EditPaymentCard: "Editar cartão de crédito",
      Copy: "Copiado",
      PaymentLinkGenerated: "Link de atualização de pagamento gerado",
      ExpiresIn: "Expira em",
      CardNumber: "Número do cartão",
      Plan: "Plano",
      Storage: "Armazenamento",
      Users: "Usuários",
      ContractValue: "Valor",
      SwitchPlansEveryMoment: "Você pode realizar alterações no seu plano a qualquer momento",
      Category: "Categoria",
      AccountPlan: {
        Free: "Gratuito",
    },
    LabelStepsPayments : {
        ValidatingData: "Validando dados",
        CreatingPaymentMethod: "Criando método de pagamento",
        UpdatingPaymentMethod: "Atualizando método de pagamento",
        Finalizing: "Finalizando",
    },
    ProcessingNewPaymentMethod: "Processando seu novo método de pagamento",
    PaymentMethodUpdatedSuccessfully: "Método de pagamento atualizado com sucesso!",
    PaymentMethodUpdatedSuccessMessage: "Seu método de pagamento foi atualizado com sucesso. Agradecemos por continuar com o KeyDrive.",
    ClickToLogoutAndRefresh: "Clique para sair e atualizar",
    TryAgain: "Tentar novamente",
    ErrorProcessingPaymentMethod: "Erro ao processar seu novo método de pagamento",
    WhatToDoNow: "O que fazer agora?",
    CheckCardDetailsAndTryAgain: "Verifique os dados do cartão e tente novamente",
    EnsureAllFieldsFilledCorrectly: "Certifique-se de que todos os campos estão preenchidos corretamente",
    ContactSupportIfProblemPersists: "Se o problema persistir, entre em contato com o suporte",
    CardDetails: "Dados do Cartão",
    BillingAddress: "Endereço de Cobrança",
    WantToCancelNow: "Quero cancelar agora",
    Back: "Voltar",
    SubscriptionCancelledSuccessfully: "Sua assinatura foi cancelada com sucesso!",
    Confirm: "Confirmar",
    CancelSubscriptionImmediatelyWarning: "Clicando no botão de confirmar sua assinatura será cancelada imediatamente, e você perderá o acesso aos recursos pagos.",
    CancelSubscriptionRightNow: "Cancelar assinatura agora mesmo"

    },
    CancelDueAlert: {
      SubscriptionScheduledForCancellation: "Sua assinatura foi programada o cancelamento para o dia",
      CheckWithAdmin: "Verifique com seu administrador a melhor forma de proceder.",
      CanCancelRequest: "pode cancelar essa requisição clicando no botão ao lado!",
      AccessAccountAndSubscription: "Acessar contas e assinatura"
    },
    Signture: {
      UnderSignture: "Você está sobre a assinatura de um plano",
      Guest: "Convidado",
      SigntureCanceledContent: "Você está utilizando o Keydrive por uma assinatura cancelada, para continuar utilizando o sistema, por favor escolha um novo plano.",
      SigntureCanceledTitle: "Sua assinatura está cancelada",
      SigntureOnHoldContent: "Sua assinatura está temporariamente indisponível. Para mais informações sobre a liberação do acesso, consulte nosso comercial.",
      SigntureOnHoldTitle: "Sua assinatura está temporariamente indisponível",
      GetIn: "Entrar em contato",
      YourPaymentMethodNeedToBeUpdatedContent: "Seu metodo de pagamento falhou. Pedimos que atualize o mais rápido possivel para não perder o acesso ao nosso sistema.",
      YourPaymentMethodNeedToBeUpdatedTitle: "Seu método de pagamento precisa ser atualizado",
      EditPaymentMethod: "Editar método de pagamento",
      YourPaymentMethodNeedToBeUpdatedContent2: "Seu metodo de pagamento falhou novamente. Pedimos que atualize o mais rápido possivel para não perder o acesso ao nosso sistema.",
      YourPaymentMethodNeedToBeUpdatedTitle2: "Seu método de precisa ser atualizado logo.",
      YourPaymentMethodNeedToBeUpdatedContent3: "Seu metodo de pagamento falhou 3x consecutivas. Pedimos que atualize o mais rápido possivel para não perder o acesso ao nosso sistema.",
      YourPaymentMethodNeedToBeUpdatedTitle3: "Seu método de pagamento precisa ser atualizado urgente.",
      SetupNewPaymentMethod: "Atualizar meu método de pagamento",
      UpdatePaymentMethodLater: "Atualizar mais tarde",
      Owner: "Proprietário"
    },
    Feed: {
      Updates: "Atualizações",
      HeaderText: "Aqui, você encontrará todas as novidades e mudanças relacionadas aos documentos.",
      NonExistingUpdates: "Atualizações inexistentes",
      NonExistingUpdatesText: "Parece que não houve nenhuma movimentação até o momento. Tente novamente mais tarde.",
      NoContentWithFilter: "Infelizmente nenhuma atualização foi encontrada para o filtro aplicado. Por favor, tente novamente.",
      NoContentFound: "Nenhuma atualização encontrada",
      AssignedTo: "Atribuído a",
      ShowAll: "Mostrar tudo (Padrão)",
      Term: "Período",
      Start: "Início",
      End: "Fim",
      Reset: "Resetar",
      ApplyFilter: "Aplicar filtro",
      Today: "Hoje",
      Yesterday: "Ontem",
      PreviousUpdates: "Atualizações anteriores",
      SeeMore: "Ver mais",
      Filters: "Filtros",
    },
    MyData: {
      Mydata: "Meus dados",
      Cancel: "Cancelar",
      Save: "Salvar",
      PersonalizeExp: "Personalize a sua experiência definindo a sua foto de perfil, informe os seus dados e mantenha a sua senha bem protegida e atualizada.",
      UploadImageTerms: "Faça upload de imagem de pelo menos 800x800px (recomendação). Somente formatos .JPG ou .PNG são aceitos.",
      Userimage: "Imagem de usuário",
      PersonaInformation: "Informações pessoais",
      Name: "Nome",
      PhoneNumber: "Número de telefone/Celular",
      Pass: "Senha",
      Login: "E-mail",
      CurrentPass: "Senha atual",
      ChangePass: "Alterar senha",
      ContantSup: "Precisa falar com o suporte?",
      ContantTeam: "Entre em contato com a nossa equipe de suporte clicando no botão ao lado",
      GetIn: "Entrar em contato",
      Uploadimage: "Upload de imagem",
      Language: "Idioma",
      Logout: "Sair",
      NewPassword: "Nova senha",
      ConfirmPassword: "Confirmar senha",
      ChangeImage: "Alterar imagem",
      Remove: "Remover",
      UserEdittedSuccessfully: "Usuário foi atualizado com sucesso"
    },
    DocumentsList: {
      DocumentsTableHeaders: {
        Name: "Nome",
        Description: "Descrição",
        CreatedAt: "Criado em",
        Tags: "Tags",
        Size: "Tamanho",
        Term: "Prazo",
      },
      SeeDocuments: "Ver Documentos"
    },
    Privileges: {
      ModifyUser: "Modificar Privilégio (Usuário)",
      AddUser: "Adicionar Privilégio (Usuário)",
      AddGroup: "Adicionar Privilégio (Grupo)",
      DefineNewPrivilege: "Defina o novo privilégio do usuário de acordo com uma das opções abaixo; Privilégio atual:",
      ModifyGroup: "Modificar Privilégio (Grupo)",
      DefineNewPrivilegeGroup: "Defina o novo privilégio do grupo de acordo com uma das opções abaixo; Privilégio atual:",
      VerifyUserPrivilegeCaption: "Confira os usuários que possuem algum privilégio no",
      Item: "Item",
      Workspace: "Workspace",
      IsSubFolder: "Essa pasta é uma subpasta; não é possivel modificar privilégios de subpastas.",
      Users: "Usuários",
      Groups: "Grupos",
      Add: "Adicionar",
      Edit: "Editar",
      DefineWithOptions: "Defina o privilégio do usuário de acordo com uma das opções abaixo:",
      DefineWithOptionsGroup: "Defina o privilégio do grupo de acordo com uma das opções abaixo:",
      Privileges: "Privilégios",
      DefinePrivilege: "Definir Privilégio",
      Organizer: "Organizador",
      Reader: "Leitor",
      Common: "Comum",
      Editor: "Editor",
      None: "Nenhum",
      OrganizerBehavior: "Não possui acesso a privilégios administrativos e não pode alterar a pasta raiz, mas pode criar novas subpastas e documentos, além de editar e excluir conteúdos existentes. As subpastas herdarão automaticamente os mesmos privilégios dos grupos e usuários da pasta raiz.",
      ReaderBehavior: "Estes usuários apenas consultam e visualizam os documentos nos Workspaces permitidos.",
      EditorBehavior: "Realiza edições na ferramenta e tem acesso as funcionalidades. Não pode criar e excluir estruturas de pastas.",
      CommonBehavior: "Usuário que pertence apenas ao workspace, mas não há nenhum privilégio até que alguém o permita.",
      ExcludeTitle: "Deseja realmente deletar esta permissão?",
      ExcludeContent: "Ao deletar a permissão, o usuário será removido do workspace e das pastas que ele possui permissões",
      Confirm: "Confirmar",
      Cancel: "Cancelar",
      Name: "Nome",
      Email: "Email",
      Phone: "Telefone",
      Privilege: "Privilégio",
      Participants: "Participantes",
      Owner: "Dono da pasta",
      NoPrivileges: "Sem privilégios atribuídos.",
      NoPrivilegesText: "Configure os privilégios necessários para o usuário acessar os recursos do sistema.",
      NoPrivilegesGroupText: "Configure os privilégios necessários para o grupo acessar os recursos do sistema."
    },
    Drag: {
      NotPossible: "Não é possível arrastar os itens enquanto estiver editando"
    },
    FileUploader: {
      UploadOfFiles: "Upload de arquivos",
      Of: "de",
      FilesInProgress: "arquivos em andamento",
      TitleModalCloseUpload: "Há arquivos em andamento... Cancelar mesmo assim?",
      SubtitleModalCloseUpload: "Parece que há arquivos que estão com o upload em andamento. Confirme se você gostaria de fechar e cancelar os arquivos em andamento.",
      TextButtonReject: "Não! Continuar uploads...",
      TextButtonAccept: "Sim, cancelar uploads.",
      Waiting: "Aguarde...",
      UploadStatus: {
        Success: "Sucesso em upload",
        Error: "Falha em upload",
        Canceled: "Upload Cancelado",
        Warning: "Aviso em upload",
        Others: "Falha desconhecida"
      }
    },
    OpenInWindows: {
      message: "Abrir no Windows",
    },  
    OpeningDocumentInWindows: {
      message: "Abrindo documento no Windows",
    },
    DownloadAgentModal: {
      haveThe: "Tenha o",
      onYourComputer: "no seu computador",
      toViewTheSelectedItemOnYourComputerClickTheButtonBelowToDownloadAndInstallThe: "Para visualizar o item selecionado no seu computador, clique no botão abaixo para baixar e instalar o",
      cancel: "Cancelar",
      downloadKeyDriveLocalEdit: "Baixar KeyDriveLocalEdit",
      openInApplication: "Abrir no aplicativo",
      OpeningDocumentInKeyDriveLocalEdit: "Abrindo documento no KeyDriveLocalEdit",
      UnsupportedBrowser: "Navegador não suportado",
    },
    BoxMfa: {
      title: "Autenticação de dois fatores",
      button: "Retornar para login"
    },
    MfaQRCode: {
      header: "Siga as etapas abaixo para conseguir acessar a sua conta.",
      tooltip: "Copiar código",
      tipPartA: "Não consegue escanear o código?",
      tipPartB: " Copie o código acima e cole no seu autenticador.",
      tipOnePartA: "Escaneie o QR Code",
      tipOnePartB:" ao lado utilizando o aplicativo de autenticação (Exemplo: Authenticator).",
      tipTwo: "Após o scan, insira nos campos abaixo o código de 6 dígitos recebido:"
    },
    OTPInput:{
      message:"Os caracteres inseridos estão incorretos."
    },
    MfaOTP:{
      header: "Você já tem o QR Code. Agora, insira o código recebido no seu aplicativo de autenticação nos campos abaixo:",
      buttonNotQRCode: "Não tenho o QR Code"
    },
    Paywall: {
      title: "Você atingiu o máximo permitido!",
      workspaceStart: "Você só pode ter " ,
      workspaceBold: "um Workspace no plano free. ",
      workspaceEnd :"Entre em contato com o suporte e solicite um upgrade no plano da sua Organização.",
      usersStart: "Você só pode ter  ",
      usersBold: "três usuários no plano free. ",
      usersEnd: "Entre em contato com o suporte e solicite um upgrade no plano da sua Organização.",
      storageStart: "Você só pode utilizar até  ",
      storageBold: "4GB de armazenamento no plano free. ",
      storageEnd: "Entre em contato com o suporte e solicite um upgrade no plano da sua Organização.",
      storageWithAdminContactStart: "Você só pode utilizar até  ",
      storageWithAdminContactBold: "4GB de armazenamento no plano free. ",
      storageWithAdminContactEnd:"Entre em contato com o usuário administrador e solicite um upgrade no plano da Organização.",
      validationRuleStart: "Você só pode ter ",
      validationRuleBold: "uma Regra de validação no plano free. ",
      validationRuleEnd: "Entre em contato com o suporte e solicite um upgrade no plano de sua Organização.",
      upgrade: "Fazer um upgrade",
      gotIt: "Entendi",
      error: "Erro ao buscar informações da organização, tente novamente"
    },
    SharedItem: {
      Title: "Compartilhados",
      Subtitle: "Aqui você pode visualizar todas as pastas e arquivos que foram compartilhados com usuários colaboradores.",
      NotFound: {
        Title: "Não há itens compartilhados",
        Subtitle: "Nenhum item foi compartilhado até o momento."
      },
      name: "Nome",
      dateShared: "Data de expiração",
      sharedBy: "Compartilhado por",
      usersWithAccess: "Usuários com acesso",
      users: "Usuários",
      theDocument : "O documento",
      hasBeenSharedSuccessfully : "foi compartilhado com sucesso.",
      favoriteSuccess: "Documento favoritado com sucesso.",
      favoriteFail: "Favorito já existente.",
      unfavoriteSuccess: "Documento removido dos favoritos com sucesso.",
      unfavoriteFail: "Erro ao encerrar compartilhamento.",
      unsharedSuccess: "Compartilhamento encerrado com",
      unsharedFail: "Erro ao parar compartilhamento.",
      all: "todos",
      noExpiration: "Sem expiração",
    },
    GenericTablePagination: {
      showing: "Mostrando",
      itemsOutOf: "itens de",
      totalItems: "itens totais."
    },
    ItemOptionsMenu: {
      download: "Baixar",
      edit: "Editar",
      copyLink: "Copiar link",
      favorite: "Favoritar",
      unfavorite: "Remover favorito",
      unshared: "Parar compartilhamento",
      all: "Todos"
    },
    ButtonWithPopoverFilter: {
      filters: "Filtros",
      viewAll: "Ver todos",
      myFiles: "Meus arquivos",
      sharedBy: "Compartilhado por",
      select: "Selecione...",
      sharedDate: "Data compartilhada",
      start: "Inicio",
      end: "Fim",
      reset: "Resetar",
      applyFilter: "Aplicar filtro"
    },  
    MoveInBatch:{
      title: "Mover itens selecionados?",
      header:"Confirme se você realmente gostaria de mover todos os itens selecionados abaixo. E por fim, defina o destino dos itens.",
      titleListItens:"Itens selecionados",
      titleMoveFor:"Mover para",
      checkbox:"Mover para raiz do Workspace"
    },
    SelectedList: {
      Name: "Nome",
      ItemSelected: "item selecionado",
      ItemsSelected: "itens selecionados"
    },
    MovedSuccess:{
      title: "Itens movidos com sucesso",
      header:"Tudo pronto! Os itens selecionados foram movidos com sucesso. Confira abaixo:",
      goToLocation:"Ir para local",
      finish:"Concluir"
    },
    Language: {
      Language: "Idioma",
      SelectPreferIdiom: "Selecione seu idioma de preferência.",
      NotFoundLanguage: "Não encontrou seu idioma? Entre em contato com o nosso suporte para avisar sobre a necessidade de um idioma específico."
    },
    PasswordMessage: {
      MinLength: "Senha menor do que esperado. Minimo 6.",
      AtLeastOneNumber: "Senha requer pelo menos 1 número.",
      EspecialValidation: "Senha requer pelo menos um caracter especial.",
      UppercaseValidation: "Senha requer pelo menos um caracter maisculo.",
      DiffPass: "Senhas diferem.",
      StartProcess: "Digite sua senha atual...",
      changedSuccessfully: "Senha alterada com sucesso."
    },
    SearchBox: {
      recentSearches: "Buscas recentes",
      noRecentLists: "Sem listagem recentes",
      searchButton: "Pesquisar",
      cleanSearches: "Limpar buscas recentes",
      seeAllResults: "Veja todos os resultados",
      tryOtherWords: "Tente pesquisar com outras palavras para tentar encontrar o que procura.",
      nothingFound: "Nenhum resultado encontrado",
      bestResults: "Resultados Principais",
      searchForContent: "Pesquisar por conteúdo",
      allWorkspaces: "Todos os Workspaces",
      inThatPage: "Nesta pasta",
      myFolderAndFiles: "Minhas pastas e arquivos",
      selectOrg: "Selecione uma organização",
      selectedWorkspace: "Selecione um workspace",
      default: "Padrão"
    },
    PleaseWaitTheOrganizationIsBeingCreated: {
      message: "Por favor aguarde, a organização está sendo criada."
    },
    RegisterPage: {
      pageTitle: "Criar uma conta",
      pageDescription: "Vamos passar por todas as etapas abaixo para criar uma nova conta para você",
      steps: {
        step1: {
          title: "Informações pessoais",
          content: "Comece informando seus dados básicos"
        },
        step2: {
          title: "Escolha uma senha",
          content: "Crie uma senha segura para proteger sua conta e seus dados."
        },
        step3: {
          title: "Informações de Organização",
          content: "Defina o nome da organização e após a criação da conta, crie workspaces para armazenar seus documentos."
        },
        step4: {
          title: "Escolha um plano",
          content: "Selecione o plano que melhor atende às suas necessidades neste momento."
        },
        step5: {
          title: "Confirmar e concluir",
          content: "Verifique se está tudo certo e conclua a criação da conta."
        }
      },
    },
    AddNewDevice: {
      NewDeviceDetectedTitle: "Novo acesso detectado na sua conta",
      NewDeviceDetectedContent: "Detectamos um novo acesso à sua conta KeyDrive. Para garantir a segurança dos seus dados, queremos confirmar se foi você.",
      AuthorizeDevice: "Autorizar dispositivo",
      MessagedSentFor: "Esta mensagem foi enviada por",
      Bom: "© 2025 KeyDrive. Todos os direitos reservados."
    },
    FreeTier: {
      FreeTitle:"Você está usando uma versão gratuita do sistema!",
      FreeContent: "Assine um de nossos planos para conseguir acesso as abas de admin.",
      AccessPlans: "Acessar Planos"
    },
    Payment:{
      CancelSubscriptionSuccess: "Você cancelou sua assinatura. Você poderá utilizar nossos serviços até o vencimento do seu dia de pagamento do próximo mês.",
      CancelSubscriptionTitle: "Infelizmente, sua assinatura foi cancelada."
    },
    DecideLater: {
      Title: "Decidir o plano mais tarde?",
      Content: "Se continuar, você poderá decidir o plano mais tarde (sem o periodo de teste), na nossa aba de planos. Você terá um acesso mínimo ao software.",
      Later: "Decidir depois",
      Cancel: "Cancelar"
    },
    NewFolder: {
      title: "Nova pasta"
    },
    DocumentActionsMenu: {
      draft: "Rascunho",
      download: "Baixar",
      release: "Publicar",
      moveTo: "Mover para",
      preValidationOfAction: "Pré-validação da ação",
      BatchDelete: "Deletar em lote"
    },
    DeleteInBatchDialog: {
      Title: "Os itens abaixo foram movidos para a lixeira",
      ErrorWhenDeletingFiles:"Houve um erro ao tentar deletar seus arquivos.",
      DeletedSuccessfully:"Deletados com sucesso",
      Selected: "Selecionados",
      NotDeleted: "Não deletados",
      GoToRecycleBin: "Ir para lixeira",
      Close: "Fechar",
      Name: "Nome",
      Extension: "Extensão",
      Status: "Status",
      ConfirmDialogTitle: "Excluir itens selecionados?",
      ConfirmDialogContent: "Confirme se você realmente gostaria de excluir os itens listados abaixo.",
      AlertTitle: "Observação",
      AlertSubtitle: "Para recuperar os itens excluídos, acesse a seção Lixeira e siga as instruções da página."
    },
    ChangedSuccessfully: {
      message: "Alterado com sucesso."
    },
    ChoosePlan: {
      title: "Planos KEY",
      subtitle: "Solução segura e escalável para gestão de documentos.",
      essentialPlan: "Essencial",
      professionalPlan: "Professional",
      scalePlan: "Scale",
      perMonth: "/mês",
      mostPopular: "Mais Popular",
      upToUsers: "Até {{count}} usuários",
      storage: "{{size}} de armazenamento",
      workspace: "{{count}} workspace",
      workspaces: "Até {{count}} workspaces",
      unlimitedWorkspaces: "Workspaces ilimitados",
      groupPermissions: "Permissões por grupo",
      versionControl: "Controle de versões",
      emailSupport: "Suporte via e-mail",
      workflowRules: "Regras de workflow e temporalidade",
      externalAPIs: "APIs externas e auditoria",
      chatSupport: "Suporte via chat",
      cadViewer: "Visualizador CAD",
      coldStorage: "Cold Storage inteligente",
      advancedReports: "Relatórios avançados",
      dedicatedSupport: "Suporte dedicado",
      startTrial: "Iniciar avaliação",
      confirmSubscription: "Confirmar Assinatura",
      cancel: "Cancelar",
      plan: "Plano",
      cardDetails: "Dados do Cartão",
      billingAddress: "Endereço de Cobrança",
      completeSubscription: "Complete sua assinatura",
      processingSubscription: "Processando sua assinatura",
      validatingData: "Validando dados",
      creatingPaymentMethod: "Criando método de pagamento",
      processingSubscriptionStep: "Processando assinatura",
      finalizing: "Finalizando",
      subscriptionCompleted: "Assinatura concluída!",
      congratulations: "Parabéns! Sua assinatura foi processada com sucesso.",
      subscriptionDetails: "Detalhes da assinatura:",
      value: "Valor:",
      email: "Email:",
      confirmationEmail: "Você receberá um email de confirmação em breve.",
      errorProcessing: "Erro ao processar assinatura",
      whatToDoNow: "O que fazer agora?",
      checkCardData: "• Verifique os dados do cartão e tente novamente",
      ensureFieldsFilled: "• Certifique-se de que todos os campos estão preenchidos corretamente",
      contactSupport: "• Se o problema persistir, entre em contato com o suporte",
      tryAgain: "Tentar novamente",
      notReadyToSubscribe: "Não está pronto para assinar agora?",
      startUsing: "Começar a usar",
      subscribeNow: "Assinar agora",
      personalPlanAlert: "Você está utilizando um plano personalizado. Para contratar um plano, entre em contato com o suporte.",
      logoutToRefreshSubscription: "Saia e entre novamente na aplicação para atualizarmos sua assinatura!",
      alreadyHaveSubscriptionError: "• Se você já possuir uma assinatura não poderá assinar novamente. Se precisar de um upgrade, contate nosso suporte.",
      UsingFreePlan: "Você está usando uma versão gratuita do software",
      FreeAdmPlan: "Para atualizar, entre no admin console e acesse nossa aba de planos!",
      NotFreeAdmPlan: "Para atualizar, entre em contato com o administrador da sua organização!"
    }
    ,
    FreeSoftwareAlert: {
      title: "Você está usando uma versão gratuita do software",
      admin: "Para atualizar, entre no admin console e acesse nossa aba de planos!",
      user: "Para atualizar, entre em contato com o administrador da sua organização!",
      button: "Acessar Planos"
    },
    Generic: {
      SuportErrorMessage: "Ocorreu um problema ao processar a solicitação. Tente novamente ou entre em contato com o suporte caso o problema persista."
    },
    View: {
      MinGroups: "Minimizar agrupamentos",
      MaxGrups: "Maximizar agrupamentos",
    }
  }
}
